import { render, staticRenderFns } from "./MappingEditorPage.vue?vue&type=template&id=b3252300&scoped=true"
import script from "./MappingEditorPage.vue?vue&type=script&lang=js"
export * from "./MappingEditorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3252300",
  null
  
)

export default component.exports